import { isString } from 'b2b-apps/shop/common/utils/string/string';

export function sanitizeCertificates(certificates: any[]): string[] {
  if (!Array.isArray(certificates)) {
    return [];
  }

  return certificates
    .filter((row) => isString(row))
    .map((row) => row.trim())
    .filter((row) => row);
}

export function isCertified(
  productCertificates: string[],
  debitorCertificates: string[],
): boolean {
  if (!Array.isArray(productCertificates) || !productCertificates.length) {
    return true;
  }

  if (!Array.isArray(debitorCertificates)) {
    return false;
  }

  const matching = productCertificates.filter((cert) => debitorCertificates.includes(cert));

  return !!matching.length;
}
